import ApiService from './';
/**
 * @heading1: Folder API service.
 * @paragraph: This module provides a set of methods to interact with the Folder API.
 * It handles operations like Fetching folder details and create folder.
 */
const FolderApi = {
    /**
     * @heading3: Fetch Folders
     * @paragraph: Sends a POST request to retrieve all folders available for the user.
     * @param: {string} token - The user's authentication token.
     * @param: {number} client_id - The parameters required id on which the folders will be fetch.
     * @returns: {Promise<unknown[]>} - The response containing a list of all folders.
     * @separator:
     */
    fetchFolders: (token: string, client_id: number) => {
        // Perform a POST request to fetch folders with the provided data
        return ApiService.apiHit({
            url: 'get-folders',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },

    /**
     * @heading3: Create Folder
     * @paragraph: Sends a POST request to Create a Folder.
     * @param: {string} token - The user's authentication token, required for authorization.
     * @param: {string} folder_name - The folder_name containing the Name of folder for the operation.
     * @param: {number} client_id - The client_id containing location for the operation.
     * @returns: {Promise<unknown[]>} - A promise that resolves to the response containing the operation result.
     * @separator:
     */
    createFolder: (token: string, folder_name: string, client_id: number) => {
        // Perform a Post request to create folder endpoint with the token
        return ApiService.apiHit({
            url: 'add-folders',
            method: 'post',
            token,
            data: {
                client_id,
                folder_name
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
     * @heading3: Delete Folder
     * @paragraph: Sends a POST request to Delete a Folder.
     * @param: {string} token - The user's authentication token, required for authorization.
     * @param: {number} folder_id - The folder_id containing the id number of folder for the operation.
     * @param: {number} client_id - The client_id containing location for the operation.
     * @returns: {Promise<unknown[]>} - A promise that resolves to the response containing the operation result.
     * @separator:
     */
    deleteFolder: (token: string, folder_id: number, client_id: number) => {
        // Perform a Post request to create folder endpoint with the token
        return ApiService.apiHit({
            url: 'delete-folder',
            method: 'post',
            token,
            data: {
                client_id,
                folder_id
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default FolderApi;
